import isMobile from 'shared/responsive-helpers'
import { TableRow, TableCell } from '@components/Table'

const Header = () => (
    <TableRow className="header">
        <TableCell className="table__cell__m" text={<T>dashboard.promotions.promo.code</T>} />
        <TableCell className="table__cell__s center" text={<T>dashboard.promotions.promo.copy</T>} />
        <TableCell className="table__cell__s" text={<T>dashboard.promotions.promo.sum</T>} />
        <TableCell className="table__cell__s" text={<T>dashboard.promotions.promo.spent</T>} />
        <TableCell className="table__cell__m" text={<T>dashboard.promotions.promo.expiryDate</T>} />
        {!isMobile() && <TableCell className="table__cell__l" />}
        <TableCell className="table__cell__xs emphasised" text={<T>dashboard.promotions.promo.balance</T>} />
    </TableRow>
)

export default Header
